<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('serviceRequest.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('serviceRequest.pageTitle'),
            href: '/admin/service-requests'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-p-2 ts-rounded-md">
          <div class="ts-grid ts-grid-cols-3 ts-gap-5">
            <div
              class="ts-w-full ts-h-full ts-border-2 ts-border-dashed ts-rounded-md ts-p-3 ts-relative"
            >
              <Connector />
              <BasicInfo
                v-model="model"
                :validate="errors"
                @setLoading="setLoading"
              />
            </div>
            <div
              class="ts-w-full ts-h-full ts-border-2 ts-border-dashed ts-rounded-md ts-p-3 ts-relative"
            >
              <Connector />
              <Client
                v-model="model"
                :validate="errors"
                @setLoading="setLoading"
              />
            </div>
            <div
              class="ts-w-full ts-h-full ts-border-2 ts-border-dashed ts-rounded-md ts-p-3 ts-relative"
            >
              <Technician v-model="model" :validate="errors" />
            </div>
          </div>
        </div>
        <div
          class="ts-p-2 ts-rounded-md"
          v-if="model.service_request_type_id == 1"
        >
          <div
            class="ts-w-full ts-h-full ts-border-2 ts-border-dashed ts-rounded-md ts-p-3 ts-relative"
          >
            <PlannedMaintenance v-model="model" :validate="errors" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-card-wrapper>
        <div class="row">
          <div
            class="col-md-12 ts-flex ts-items-center ts-justify-end ts-space-x-3"
          >
            <ts-button
              :disabled="loading"
              @click.prevent="$router.push({ name: 'service-request' })"
              >{{ $t('cancel') }}
            </ts-button>
            <ts-button
              :disabled="loading"
              @click.prevent="onSaveAddNew"
              outline
              color="primary"
              >{{ $t('saveAddNew') }}
            </ts-button>
            <ts-button
              :disabled="loading"
              @click.prevent="onSave"
              color="primary"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import Connector from './components/form/connector.vue'
import BasicInfo from './components/form/basic-info.vue'
import Client from './components/form/client.vue'
import Technician from './components/form/technician.vue'
import PlannedMaintenance from './components/form/planned-maintenance.vue'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import { debounce } from 'lodash'

export default {
  components: {
    Connector,
    BasicInfo,
    Client,
    Technician,
    PlannedMaintenance
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      model: {
        service_request_id: null,
        service_request_no: null,
        service_request_date: moment().format('DD-MM-YYYY'),
        service_request_type_id: null,
        fee_type_id: null,
        requested_by: null,
        request_photo: null,
        service_status: 0,
        required_spare_part: false,
        input_source: 'W',
        product_id: null,
        stock_out_id: null,
        serial_no: null,
        owner: null,
        remarks: null,
        comment: null,
        order_kads: null,
        informant: null,
        province_code: null,
        district_code: null,
        commune_code: null,
        village_code: null,
        plate_number: null,
        technician1: null,
        technician2: null,
        contact_number: null,
        open_date: null,
        close_date: null,
        planned_maintenance: []
      }
    }
  },
  computed: {
    ...mapState('serviceManagement/serviceRequest', ['formViewDatas'])
  },
  created() {
    this.getPreData({
      params: {},
      index: undefined
    })
    this.model.owner = this.$store.state.authUser.user.user_id
    this.errors = new Errors()
  },
  methods: {
    ...mapActions('serviceManagement/serviceRequest', [
      'getFormViewModel',
      'store'
    ]),
    async getPreData({ params, index }) {
      this.loading = true
      await this.getFormViewModel({ index: index, params: params })
      this.loading = false
    },
    onSave() {
      this.loading = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'service-request' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSaveAddNew() {
      this.loading = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInput() {
      this.model.service_request_id = null
      this.model.service_request_no = null
      this.model.service_request_date = moment().format('DD-MM-YYYY')
      this.model.service_request_type_id = null
      this.model.fee_type_id = null
      this.model.requested_by = null
      this.model.request_photo = null
      this.model.service_status = 0
      this.model.required_spare_part = false
      this.model.input_source = 'W'
      this.model.product_id = null
      this.model.stock_out_id = null
      this.model.serial_no = null
      this.model.owner = null
      this.model.remarks = null
      this.model.comment = null

      this.model.order_kads = null
      this.model.informant = null
      this.model.province_code = null
      this.model.district_code = null
      this.model.commune_code = null
      this.model.village_code = null
      this.model.plate_number = null
      this.model.technician1 = null
      this.model.technician2 = null
      this.model.contact_number = null
      this.model.open_date = null
      this.model.close_date = null

      this.model.planned_maintenance = null
      this.$store.commit('serviceManagement/serviceRequest/SET_EDIT_DATA', {})
    },
    generatePlanned() {
      this.model.planned_maintenance = []
      if (this.model.service_request_type_id == 1 && this.model.stock_out_id) {
        let service_request_schedule = this.$store.state.serviceManagement.serviceRequest.formViewDatas[
          'serviceRequestTypes'
        ].find(
          el => el.service_request_type_id == this.model.service_request_type_id
        ).service_request_schedule

        let invoice = this.$store.state.serviceManagement.serviceRequest.formViewDatas[
          'invoices'
        ].find(el => el.stock_out_id == this.model.stock_out_id)

        let stock_out_date = invoice ? invoice.stock_out_date : null

        service_request_schedule.forEach(el => {
          let newItem = {
            service_request_no: null,
            service_request_date: moment(stock_out_date, 'DD-MM-YYYY')
              .add(el, 'months')
              .format('DD-MM-YYYY'),
            service_request_type_id: this.model.service_request_type_id,
            fee_type_id: this.model.fee_type_id,
            requested_by: this.model.requested_by,
            request_photo: this.model.request_photo,
            service_status: this.model.service_status,
            required_spare_part: this.model.required_spare_part,
            input_source: this.model.input_source,
            product_id: this.model.product_id,
            stock_out_id: this.model.stock_out_id,
            serial_no: this.model.serial_no,
            owner: this.model.owner,
            remarks: this.model.remarks,
            order_kads: this.model.order_kads,
            informant: this.model.informant,
            province_code: this.model.province_code,
            district_code: this.model.district_code,
            commune_code: this.model.commune_code,
            village_code: this.model.village_code,
            plate_number: this.model.plate_number,
            technician1: this.model.technician1,
            technician2: this.model.technician2,
            contact_number: this.model.contact_number
          }
          this.model.planned_maintenance.push(newItem)
        })
      }
    },
    setLoading(value) {
      this.loading = value
    }
  },
  watch: {
    'model.service_request_type_id': debounce(function() {
      this.generatePlanned()
    }, 500),
    'model.fee_type_id': debounce(function() {
      this.generatePlanned()
    }, 500),
    'model.service_status': debounce(function() {
      this.generatePlanned()
    }, 500),
    'model.requested_by': debounce(function() {
      this.generatePlanned()
    }, 500),
    'model.stock_out_id': debounce(function() {
      this.generatePlanned()
    }, 500),
    'model.product_id': debounce(function() {
      this.generatePlanned()
    }, 500),
    'model.serial_no': debounce(function() {
      this.generatePlanned()
    }, 500),
    'model.owner': debounce(function() {
      this.generatePlanned()
    }, 500),
    'model.remarks': debounce(function() {
      this.generatePlanned()
    }, 500),
    'model.required_spare_part': debounce(function() {
      this.generatePlanned()
    }, 500),
    'model.order_kads': debounce(function() {
      this.generatePlanned()
    }, 500),
    'model.informant': debounce(function() {
      this.generatePlanned()
    }, 500),
    'model.province_code': debounce(function() {
      this.generatePlanned()
    }, 500),
    'model.district_code': debounce(function() {
      this.generatePlanned()
    }, 500),
    'model.commune_code': debounce(function() {
      this.generatePlanned()
    }, 500),
    'model.village_code': debounce(function() {
      this.generatePlanned()
    }, 500),
    'model.plate_number': debounce(function() {
      this.generatePlanned()
    }, 500),
    'model.technician1': debounce(function() {
      this.generatePlanned()
    }, 500),
    'model.technician2': debounce(function() {
      this.generatePlanned()
    }, 500),
    'model.contact_number': debounce(function() {
      this.generatePlanned()
    }, 500)
  }
}
</script>
<style scoped>
* {
  font-family: Roboto, Khmer, 'Font Awesome 5 Free';
}
</style>
